import styled from 'styled-components'

export const StyledDateTimePicker = styled.div`
  display: flex;
  
  & > div:nth-last-of-type(1) {
    margin-left: 10px;
  }
`
